<div class="web-page">
  <!-- Type of the web page. Can be: article, photo, audio, video, document, profile, app, or something else -->
  <div class="site">
    <app-link class="site__name" [url]="webPage?.url" [displayText]="webPage?.siteName"></app-link>

    <div class="site__title">{{ webPage?.title }}</div>

    <div class="site__description">{{ getSmallDescription(webPage?.description?.text) }}</div>

    <div *ngIf="webPage?.photo" class="site__img" [class.tui-skeleton]="!photo.src">
      <img
        #photo
        width="100%"
        [src]="photoPath | safe: 'url'"
        [alt]="'common.labels.picture' | translate"
        (click)="viewImage()"
      />
    </div>
  </div>
</div>
